import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App.tsx';
import reportWebVitals from './reportWebVitals';
import store from './redux/store';
import { attachUiResizeListener } from './redux/uiSlice';
import { Provider } from 'react-redux';
import { initAnalytics } from './util/analytics';

initAnalytics();

if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

// keep UI breakpoints in sync with viewport changes
attachUiResizeListener(store.dispatch);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

reportWebVitals(() => {});